import {useEffect, useState} from 'react'
import { useCurrent,usePost } from '../../hooks';
import ServiceForm from './form/ServiceForm';
import { useTranslation } from 'react-i18next';

const AddNewRatingService = ({
    onSubmitCallBack = ()=>{}
}) => {
    const [t] = useTranslation('global')
    const [formState,setFormState] = useState({
        serviceName: '',
        serviceNameEn: '',
        serviceDesc: '',
        serviceDescEn: '',
        serviceLogo: '',
        defaultLanguage: '',
        showEmployeeRating: true,
        showPricesQuestion: true,
        showHowToImprove: true,
        showMobileNumber: true,
        showServiceName: true,
        showServiceDesc: true,
    });
    const [errors,setErrors] = useState();
    const {currentTenantId,currentBranchId,currentCompanyId} = useCurrent(); 
    const {data:postResult,loading:postLoading,postData} = usePost();
    const {data:uploadResult,loading:uploadLoading,postData:uploadLogo} = usePost(false);

    const saveHanlder = () => {
        setErrors({});
        
        if(!formState.serviceName){
            setErrors((state) =>({...state,serviceName:t('services.validation.nameRequired')}));
            return;
        }

        const _data = {
            "serviceName": formState.serviceName,
            "serviceNameEn": formState.serviceNameEn,
            "serviceDesc": formState.serviceDesc,
            "serviceDescEn": formState.serviceDescEn,
            "serviceLogo": formState.serviceLogo,
            "defaultLanguage": formState.defaultLanguage,
            // "isDefault": true,
            "isActive" : true,
            "showEmployeeRating": formState.showEmployeeRating,
            "showPricesQuestion": formState.showPricesQuestion,
            "showHowToImprove": formState.showHowToImprove,
            "showMobileNumber": formState.showMobileNumber,
            "showServiceName": formState.showServiceName,
            "showServiceDesc": formState.showServiceDesc,
            "tenantId": currentTenantId,
            "branchId": currentBranchId,
            "companyId": currentCompanyId
        }
        postData(`${process.env.REACT_APP_RATING_API_BASE_URL}/services`,_data)
        console.log(_data);
    }

    useEffect(() => {
        if(postResult){
            onSubmitCallBack();
        }
    },[postResult])

    useEffect(() => {
        if (uploadResult?.status === 1 && uploadResult?.data?.url) {
            setFormState((state) => ({ ...state, serviceLogo: uploadResult.data.url }));
        }
    }, [uploadResult]);

    const uploadLogoHandler = (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        const formData = new FormData();
        formData.append('serviceLogo', file, file.name);
        uploadLogo(`${process.env.REACT_APP_RATING_API_BASE_URL}/services/upload-logo`, formData);
    };

    return (
        <div>
            <ServiceForm
                    errors = {errors}
                    formState = {formState}
                    setFormState = {setFormState}
                    saveHanlder = {saveHanlder}
                    uploadLogoHandler = {uploadLogoHandler}
                    uploadLoading = {uploadLoading}
                />
        </div>
    )
}

export default AddNewRatingService
